// import { Plus } from 'lucide-react'
// import React from 'react'
// import './Payment.css'

// const Payment = () => {
//   return (
//     <>
//         <div className="payment-container">
//         <h1 className="payment-heading">Payment Voucher</h1>

//         {/* ================= FORM ================= */}
//         <section className="payment-top">
//           <form className="payment-form" >
//             <div className="payment-form-section">
//               <div className="payment-form-input-fields">
//                 <label>Branch</label>
//                 <select name="paymentType" >
//                   <option value=""></option>
//                 </select>
//               </div>

//               <div className="payment-form-input-fields">
//                 <label>Date</label>
//                 <input type="date" name="date"  />
//               </div>

//               <div className="payment-form-input-fields">
//                 <label>Voucher Type</label>
//                 <select name="fromBranch"  >
//                   <option value=""></option>
//                 </select>
//               </div>

//               <div className="payment-form-input-fields">
//                 <label>CR. Account</label>
//                 <select name="toBranch"  >
//                   <option value=""></option>
//                 </select>
//               </div>

//               <div className="payment-form-input-fields">
//                 <label>DR. Account</label>
//                 <select name="fromLedger" >
//                   <option value=""></option>
//                 </select>
//               </div>

//               <div className="payment-form-input-fields">
//                 <label>Amount</label>
//                 <input type="text" />
//               </div>
//             </div>

//             <div className="payment-narration-input">
//               <label>Narration</label>
//               <textarea name="narration" ></textarea>
//             </div>

//             <div className="payment-form-submit-btn">
//               <button type="submit">Save</button>
//             </div>
//           </form>
//         </section>

//         {/* ================= REPORT SECTION ================= */}
//         <div className="payment-report-container">
//           <div className="payment-report-table-container">
//             <h1>Payment Voucher Report</h1>
//             <div className="payment-report-table">
//             <table>
//               <thead>
//                 <tr>
//                   <th>SN.</th>
//                   <th>Particular</th>
//                   <th className="amount-head">
//                     <div className="payment-th-data">
//                       <h4>Amount</h4>
//                       <div className="payment-th-amount">
//                         <span>DR</span>
//                         <span>CR</span>
//                       </div>
//                     </div>
//                   </th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {/* Row Sample */}
//                 <tr>
//                   <td>1</td>
//                   <td></td>
//                   <td className="amount-row">
//                     <span>200</span>
//                     <span>0</span>
//                   </td>
//                 </tr>

//                 {/* Footer Total Row */}
//                 <tr className="totalRow">
//                   <td colSpan="2">TOTAL</td>
//                   <td>
//                     <div className="payment-th-amount">
//                       <p>200</p>
//                       <p>0</p>
//                     </div>
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//           </div>
//           </div>
//         </div>
//     </>
//   )
// }

// export default Payment



import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Payment.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
import { toast } from "react-toastify";

const API_URL = "https://payyug.in/api";

const Payment = () => {
  const [branchLedgers, setBranchLedgers] = useState([]);
  const [selectedBranchLedger, setSelectedBranchLedger] = useState(null);

  const [formData, setFormData] = useState({
    voucherType: "payment",
    date: "",
    narration: "",
    amount: "",
    ledgerType: "",
    paymentAccount: "",
  });

  const { profile } = useSelector((state) => state.userProfile);
  const dispatch=useDispatch();

  console.log(profile)


    // ✅ Fetch Profile
    useEffect(() => {
      dispatch(fetchUserProfile());
    }, [dispatch]);

  /* ================= FETCH BRANCH LEDGER LIST================= */
  useEffect(() => {
    const fetchBranchLedgers = async () => {
      try {
        const res = await axios.get(`${API_URL}/branch-ledger/get-all`, {
          params: {
            superAdminId: profile?.superAdminId,
            branch_id: profile?.branchId,

          },
        });
        console.log("branch ledgers", res.data);
        setBranchLedgers(res?.data?.data || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchBranchLedgers();
  }, [profile]);

  /* ================= HANDLE CHANGE ================= */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  console.log("selected branch ledger", selectedBranchLedger?.id);
  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedBranchLedger) {
      toast.warn("Please select DR Account");
      return;
    }

    if (!formData.paymentAccount) {
      toast.warn("Please select CR Account");
      return;
    }

    if (!formData.amount) {
      toast.warn("Amount is required");
      return;
    }

    const payload = {
      voucherType: formData.voucherType,
      voucherNo: `PAY${Date.now()}`,
      date: formData.date,
      narration: formData.narration,
      branchId: profile?.branchId,
      superAdminId: profile?.superAdminId,
      createdBy: profile?.branchId,

      entry: {
        ledgerId: Number(selectedBranchLedger?.id),
        amount: Number(formData.amount),
        ledgerType: selectedBranchLedger.ledger.name,
      },
      paymentAccountLedgerId: formData.paymentAccount === "Cash" ? 1 : 2,
    };

    try {
      const res=await axios.post(`${API_URL}/ledger-entry/create-voucher`, payload);

      toast.success(res?.data?.message||"Payment Voucher Created Successfully");

      // reset
      setFormData({
        voucherType: "payment",
        date: "",
        narration: "",
        amount: "",
        ledgerType: "",
        paymentAccount: "",
      });
      setSelectedBranchLedger(null);
    } catch (err) {
      console.error(err);
      toast.error(
        err?.response?.data?.message || "Failed to create payment voucher"
      );
    }
  };

  return (
    <div className="payment-container">
      <h1 className="payment-heading">Payment Voucher</h1>

      <div className="payment-top">
        <form className="payment-form" onSubmit={handleSubmit}>
          <div className="payment-form-section">

            {/* Voucher Type */}
            <div className="payment-form-input-fields">
              <label>Voucher Type</label>
            <input value="Payment" style={{fontWeight:"600"}} disabled />
            </div>

             {/* Date */}
            <div className="payment-form-input-fields">
              <label>Date</label>
              <input
              required
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
              />
            </div>

            {/* CR Account */}
            <div className="payment-form-input-fields">
              <label>CR. Account</label>
              <select
                name="paymentAccount"
                value={formData.paymentAccount}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option value="Bank">Bank A/C</option>
                <option value="Cash">Cash</option>
              </select>
            </div>

            {/* DR Account */}
            <div className="payment-form-input-fields">
              <label>DR. Account</label>
              <select
                value={selectedBranchLedger?.id || ""}
                onChange={(e) => {
                  const branchLedger = branchLedgers.find(
                    (bl) => bl.id === Number(e.target.value)
                  );
                  setSelectedBranchLedger(branchLedger);
                }}
              >
                <option value="">Select Branch Ledger</option>
                {branchLedgers.map((bl) => (
                  <option key={bl.id} value={bl.id}>
                    {bl.ledger.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Amount */}
            <div className="payment-form-input-fields">
              <label>Amount</label>
              <input
                type="number"
                name="amount"
                value={formData.amount}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Narration */}
          <div className="payment-narration-input">
            <label>Narration</label>
            <textarea
            required
              name="narration"
              value={formData.narration}
              onChange={handleChange}
            />
          </div>

          <div className="payment-form-submit-btn">
            <button type="submit">Save</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Payment;
